var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"common-box"},[_c('div',{staticClass:"bd"},[_c('a',{staticClass:"btn",on:{"click":_vm.setUserDistributor}},[_vm._v("设置分销员")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }